import { EventBus } from "../../util/event/EventBus";
import { AppModel } from "./AppModel";
/**
 * AppCore.ts
 */
export class AppCore {
    constructor() {
        if (AppCore.instance) {
            throw new Error("AppCore Singleton Already Initialised");
        }
        this.create();
        AppCore.instance = this;
    }
    create() {
        this.eventBus = new EventBus();
        this.model = new AppModel();
    }
    initialise(parameters) {
        this.model.initialise(parameters);
    }
    setTime(value) {
        this.model.setTime(value);
    }
    setOperatorData(value) {
        this.model.setOperatorData(value);
    }
    setWrapperObject(value) {
        this.model.setWrapperObject(value);
    }
    /**
     * Don't forget to call `removeEventListener`.
     */
    addEventListener(type, handler, scope) {
        this.eventBus.addEventListener(type, handler, scope);
    }
    /**
     * Must have an entry for every `addEventListener`
     */
    removeEventListener(type, scope) {
        this.eventBus.removeEventListener(type, scope);
    }
    removeEventListenersFor(scope) {
        this.eventBus.removeEventListenersFor(scope);
    }
    dispatchEvent(event) {
        this.eventBus.dispatchEvent(event);
    }
    async dispatchBlockingEvent(event) {
        await this.eventBus.dispatchBlockingEvent(event);
    }
    getModel() {
        return this.model;
    }
    getTime() {
        return this.model.getTime();
    }
    getOperatorData() {
        return this.model.getOperatorData();
    }
    getWrapperObject() {
        return this.model.getWrapperObject();
    }
    getEventBus() {
        return this.eventBus;
    }
    static getInstance() {
        if (AppCore.instance === null) {
            AppCore.instance = new AppCore();
        }
        return AppCore.instance;
    }
}
AppCore.instance = null;
//# sourceMappingURL=AppCore.js.map